import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import offerData from "../data/offerData";
import secure from "../img/secure.svg";
import { primaryBtn } from "../styles";

function Offers() {
  const iconData = offerData();

  return (
    <OfferContainer id="Offers">
      <div className="icons-container">
        <div className="icon-header">
          <h2 className="icon-h2">What can we help you with today?</h2>
          <p>I'm interested in...</p>
        </div>

        <div className="item-container">
          {iconData.map((e, i) => {
            return (
              <div key={i} className="icon">
                <div className="icon-img">
                  <img src={e.img} alt={e.title} />
                </div>
                <h4 className="icon-title">{e.title}</h4>
              </div>
            );
          })}
        </div>
      </div>

      <div className="line"></div>

      <SecurityContainer>
        <div className="secure-info">
          <h2>Safe and secure banking</h2>
          <p>
            Your safety and security is a top priority for us. We use proven
            security technology, strict privacy standards, identity confirmation
            controls and 24/7/365 real-time monitoring on transactions.
          </p>
          <LearnMore>Learn More</LearnMore>
        </div>

        <div className="secure-img">
          <img src={secure} alt="mazuma secure icon" />
        </div>
      </SecurityContainer>
    </OfferContainer>
  );
}

export default Offers;

const OfferContainer = styled(motion.div)`
  width: 100%;
  min-height: 10vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Roboto", sans-serif;

  @media (min-width: 1600px) {
    width: 100rem;
  }

  .icons-container {
    width: 100%;
    padding: 0rem 12rem;
    margin-top: 10vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (min-width: 1700px) {
      margin-top: 0vh;
      margin-top: 5rem;
    }

    // could be a mistake
    @media (max-width: 600px) {
      margin-top: 3rem;
    }

    .icon-header {
      padding: 1rem 0rem;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      @media (max-width: 600px) {
        padding: 0rem;
      }

      p {
        padding: 1rem 0rem;
        font-family: "Roboto", sans-serif;
      }
    }
    .icon-h2 {
      font-size: 2rem;
      font-family: "Roboto", sans-serif;

      @media (max-width: 600px) {
        white-space: normal;
        text-align: center;
      }
    }

    @media (max-width: 1024px) {
      padding: 0rem 2rem;
    }

    @media (max-width: 800px) {
      padding: 0rem 2rem;
    }
  }

  .item-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .icon {
      display: flex;
      min-height: 8rem;
      width: 6rem;
      padding: 1rem;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      cursor: pointer;

      :hover {
      }

      .icon-title {
        text-decoration: underline;
        z-index: 10;
      }

      .icon-title:hover {
        color: #11698e;
      }

      .icon-img {
        width: 100%;
        height: 100%;

        img {
          width: 3rem;
          height: 3rem;
          object-fit: cover;
        }
      }
    }
  }

  .line {
    margin-top: 2rem;
    width: 100rem;
    background: #e7e7e7;
    height: 2px;
  }
`;

const SecurityContainer = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  overflow: hidden;

  padding: 1rem 12.5rem;
  background: #f8f1f1;

  @media (min-width: 1600px) {
    width: 100rem;
  }

  @media (max-width: 1300px) {
    padding: 1rem 5rem;
  }

  @media (max-width: 1024px) {
    flex-wrap: wrap;
    padding: 0rem 3rem;
  }

  @media (max-width: 440px) {
    flex-wrap: wrap;
    padding: 0rem 1rem;
  }

  @media (max-width: 995px) {
    justify-content: center;
  }

  .secure-info {
    width: 100%;
    flex: 1 1 40rem;
    padding-right: 3rem;
    padding: 2rem 0rem;
    padding-right: 2rem;

    @media (max-width: 995px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    @media (max-width: 440px) {
      padding-right: 0rem;
    }

    h2,
    p {
      white-space: normal;
      padding-bottom: 2rem;
      font-family: "Roboto", sans-serif;
      line-height: 1.8rem;
    }

    h2 {
      font-size: 2rem;
    }

    p {
      font-size: 1.1rem;

      @media (max-width: 440px) {
        font-size: 1rem;
      }
    }
  }

  .secure-img {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-align: end;
    flex: 1 1 10rem;
    padding: 2rem 0rem;
    width: 100%;

    img {
      animation: changewidth 5s infinite ease-in-out;

      @keyframes changewidth {
        0% {
          transform: perspective(100rem) rotateY(0deg);
        }

        50% {
          transform: perspective(100rem) rotateY(-20deg);
        }

        100% {
          transform: perspective(100rem) rotateY(0deg);
        }
      }
    }

    @media (max-width: 1284px) {
      justify-content: center;
      text-align: center;
    }

    @media (max-width: 500px) {
      justify-content: center;
      text-align: center;

      img {
        width: 10rem;
      }
    }
  }
`;

const LearnMore = styled(primaryBtn)`
  color: white;
  background: #19456b;
`;
